/**
* Slick Carousel - http://kenwheeler.github.io/slick/
*
* All settings for each slider are on data attributes 'data-slick'
*
* If you want the slider to be controlled by a custom navigation
* set a data attribute on each nav item to correspond to the slide
* you wish to navigate to as well as which slider on the page you
* wish to control.
*
* <ul class="js-slick-nav" data-slick-nav-for="js-product-slider">
* 	<li>
* 		<button data-slide="0">
* 			Slide one
* 		</button>
* 	</li>
* 	...
* </ul>
*
*/

// Dependencies
import $ from 'jquery';
require('slick-carousel');

// Cached elements
const $el = {
	slider: $('.js-slick'),
	sliderCustomArrows: $('.js-slick-custom-arrows'),
	sliderVertical: $('.js-slick-vertical'),
	sliderNav: $('.js-slick-nav')
};

export default function init() {
	// Initialise Slick
	$el.slider.each(function() {

		$(this).slick({ // Settings are on data attributes
			slidesToShow: $(this).data('slidestoshow'),
			slidesToScroll: $(this).data('slidestoscroll'),

			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: $(this).data('slidestoshow@large'),
						slidesToScroll: $(this).data('slidestoscroll@large'),
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: $(this).data('slidestoshow@medium'),
						slidesToScroll: $(this).data('slidestoscroll@medium'),
					}
				},
				{
					breakpoint: 541,
					settings: {
						slidesToShow: $(this).data('slidestoshow@small'),
						slidesToScroll: $(this).data('slidestoscroll@small'),
					}
				},
				{
					breakpoint: 401,
					settings: {
						slidesToShow: $(this).data('slidestoshow@xsmall'),
						slidesToScroll: $(this).data('slidestoscroll@xsmall'),
						// arrows: false
					}
				}
			]
		});
		bindEvents($(this));
	});

	// having to add these because custom arrows do NOT work as data attribute
	$el.sliderCustomArrows.each(function() {
		$(this).slick({ // Settings are on data attributes
			slidesToShow: $(this).data('slidestoshow'),
			slidesToScroll: $(this).data('slidestoscroll'),
			nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 60 58.5" style="enable-background:new 0 0 60 58.5;" xml:space="preserve" class="o-arrow"> <g> <path class="o-arrow__shape" d="M56.6,3C53.8,2.3,46.4,1.1,30,1.1C13.6,1.1,6.2,2.3,3.4,3C2.4,3.2,1.8,4,1.8,5v48.6c0,1,0.7,1.8,1.6,2 c2.9,0.7,10.2,1.9,26.6,1.9c16.4,0,23.8-1.2,26.6-1.9c0.9-0.2,1.6-1.1,1.6-2V5C58.2,4,57.6,3.2,56.6,3z"/> </g> <g> <path class="o-arrow__outline" d="M30,58.5c-16.4,0-23.9-1.2-26.9-1.9c-1.4-0.3-2.4-1.6-2.4-3V5c0-1.4,1-2.6,2.3-3c3-0.7,10.4-1.9,26.9-1.9 c16.4,0,23.9,1.2,26.9,1.9c1.4,0.3,2.4,1.6,2.4,3v48.6c0,1.4-1,2.7-2.4,3C53.9,57.3,46.4,58.5,30,58.5z M30,2.1 C13.8,2.1,6.5,3.2,3.6,3.9C3.1,4,2.8,4.5,2.8,5v48.6c0,0.5,0.3,0.9,0.8,1c2.9,0.7,10.2,1.9,26.4,1.9c16.2,0,23.5-1.2,26.4-1.9 c0.5-0.1,0.8-0.5,0.8-1V5c0-0.5-0.3-0.9-0.8-1l0,0C53.5,3.2,46.2,2.1,30,2.1z"/> </g> <polygon class="o-arrow__arrow" points="36.7,18.4 34.9,19.5 40.6,28.5 16.8,28.5 16.8,30.6 40.7,30.6 34.9,39.6 36.7,40.7 43.2,30.5 43.2,28.8 "/> </svg></button>',
			prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 60 58.5" style="enable-background:new 0 0 60 58.5;" xml:space="preserve" class="o-arrow"> <g> <path class="o-arrow__shape" d="M56.6,3C53.8,2.3,46.4,1.1,30,1.1C13.6,1.1,6.2,2.3,3.4,3C2.4,3.2,1.8,4,1.8,5v48.6c0,1,0.7,1.8,1.6,2 c2.9,0.7,10.2,1.9,26.6,1.9c16.4,0,23.8-1.2,26.6-1.9c0.9-0.2,1.6-1.1,1.6-2V5C58.2,4,57.6,3.2,56.6,3z"/> </g> <g> <path class="o-arrow__outline" d="M30,58.5c-16.4,0-23.9-1.2-26.9-1.9c-1.4-0.3-2.4-1.6-2.4-3V5c0-1.4,1-2.6,2.3-3c3-0.7,10.4-1.9,26.9-1.9 c16.4,0,23.9,1.2,26.9,1.9c1.4,0.3,2.4,1.6,2.4,3v48.6c0,1.4-1,2.7-2.4,3C53.9,57.3,46.4,58.5,30,58.5z M30,2.1 C13.8,2.1,6.5,3.2,3.6,3.9C3.1,4,2.8,4.5,2.8,5v48.6c0,0.5,0.3,0.9,0.8,1c2.9,0.7,10.2,1.9,26.4,1.9c16.2,0,23.5-1.2,26.4-1.9 c0.5-0.1,0.8-0.5,0.8-1V5c0-0.5-0.3-0.9-0.8-1l0,0C53.5,3.2,46.2,2.1,30,2.1z"/> </g> <polygon class="o-arrow__arrow" points="36.7,18.4 34.9,19.5 40.6,28.5 16.8,28.5 16.8,30.6 40.7,30.6 34.9,39.6 36.7,40.7 43.2,30.5 43.2,28.8 "/> </svg></button>',
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: $(this).data('slidestoshow@large'),
						slidesToScroll: $(this).data('slidestoscroll@large'),
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: $(this).data('slidestoshow@medium'),
						slidesToScroll: $(this).data('slidestoscroll@medium'),
					}
				},
				{
					breakpoint: 541,
					settings: {
						slidesToShow: $(this).data('slidestoshow@small'),
						slidesToScroll: $(this).data('slidestoscroll@small'),
					}
				},
				{
					breakpoint: 401,
					settings: {
						slidesToShow: $(this).data('slidestoshow@xsmall'),
						slidesToScroll: $(this).data('slidestoscroll@xsmall'),
						// arrows: false
					}
				}
			]
		});
		bindEvents($(this));
	});

	$el.sliderVertical.each(function() {
		$(this).slick({ // Settings are on data attributes
			slidesToShow: $(this).data('slidestoshow'),
			slidesToScroll: $(this).data('slidestoscroll'),
			nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 400 400" style="enable-background:new 0 0 400 400;" xml:space="preserve" class="o-arrow o-arrow--up"> <path class="o-arrow__shape" d="M383.2,18.3c-19.8-4.8-70.5-13-183.7-13c-113.2,0-163.9,8.3-183.7,13C9.3,19.9,4.8,25.6,4.8,32.2v335.6 c0,6.6,4.5,12.4,11,13.9c19.8,4.8,70.5,13,183.8,13c113.2,0,163.9-8.3,183.7-13c6.4-1.5,11-7.3,11-13.9V32.3 C394.1,25.6,389.6,19.9,383.2,18.3z"/> <path class="o-arrow__outline" d="M199.5,400c-113.2,0-164.5-8.2-185-13.2c-8.8-2.1-15-9.9-15-19V32.2c0-9.1,6.2-16.9,15-19c20.5-4.9,71.7-13.2,185-13.2 c113.2,0,164.5,8.2,185,13.2l0,0c8.8,2.1,15,9.9,15,19v335.6c0,9.1-6.2,16.9-15,19C364,391.8,312.7,400,199.5,400z M199.4,10.6 c-112.2,0-162.5,8.1-182.5,12.9c-4.1,1-6.9,4.6-6.9,8.8v335.6c0,4.2,2.8,7.8,6.9,8.8c20.1,4.8,70.4,12.9,182.5,12.9 c112.1,0,162.5-8.1,182.5-12.9c4.1-1,6.9-4.6,6.9-8.8V32.3c0-4.2-2.8-7.8-6.9-8.8l0,0C361.9,18.7,311.5,10.6,199.4,10.6z"/> <path class="o-arrow__arrow" d="M327.2,219.8l-116.6-72.6c-7.5-4.7-17.2-4.7-24.7,0L71.7,219.7l-5.7-8.9l114.2-72.6c10.9-6.9,25-6.9,35.9,0l116.6,72.6 L327.2,219.8z"/> </svg></path></button>',
			prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 400 400" style="enable-background:new 0 0 400 400;" xml:space="preserve" class="o-arrow o-arrow--up"> <path class="o-arrow__shape" d="M383.2,18.3c-19.8-4.8-70.5-13-183.7-13c-113.2,0-163.9,8.3-183.7,13C9.3,19.9,4.8,25.6,4.8,32.2v335.6 c0,6.6,4.5,12.4,11,13.9c19.8,4.8,70.5,13,183.8,13c113.2,0,163.9-8.3,183.7-13c6.4-1.5,11-7.3,11-13.9V32.3 C394.1,25.6,389.6,19.9,383.2,18.3z"/> <path class="o-arrow__outline" d="M199.5,400c-113.2,0-164.5-8.2-185-13.2c-8.8-2.1-15-9.9-15-19V32.2c0-9.1,6.2-16.9,15-19c20.5-4.9,71.7-13.2,185-13.2 c113.2,0,164.5,8.2,185,13.2l0,0c8.8,2.1,15,9.9,15,19v335.6c0,9.1-6.2,16.9-15,19C364,391.8,312.7,400,199.5,400z M199.4,10.6 c-112.2,0-162.5,8.1-182.5,12.9c-4.1,1-6.9,4.6-6.9,8.8v335.6c0,4.2,2.8,7.8,6.9,8.8c20.1,4.8,70.4,12.9,182.5,12.9 c112.1,0,162.5-8.1,182.5-12.9c4.1-1,6.9-4.6,6.9-8.8V32.3c0-4.2-2.8-7.8-6.9-8.8l0,0C361.9,18.7,311.5,10.6,199.4,10.6z"/> <path class="o-arrow__arrow" d="M327.2,219.8l-116.6-72.6c-7.5-4.7-17.2-4.7-24.7,0L71.7,219.7l-5.7-8.9l114.2-72.6c10.9-6.9,25-6.9,35.9,0l116.6,72.6 L327.2,219.8z"/> </svg></path></button>',
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: $(this).data('slidestoshow@large'),
						slidesToScroll: $(this).data('slidestoscroll@large'),
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: $(this).data('slidestoshow@medium'),
						slidesToScroll: $(this).data('slidestoscroll@medium'),
					}
				},
				{
					breakpoint: 541,
					settings: {
						slidesToShow: $(this).data('slidestoshow@small'),
						slidesToScroll: $(this).data('slidestoscroll@small'),
					}
				},
				{
					breakpoint: 401,
					settings: {
						slidesToShow: $(this).data('slidestoshow@xsmall'),
						slidesToScroll: $(this).data('slidestoscroll@xsmall'),
						// arrows: false
					}
				}
			]
		});
		bindEvents($(this));
	});
	
	if ($el.sliderNav.length) {
		$el.sliderNav.each(function() {
			sliderNav($(this));
		});
	}
}

function bindEvents($slider) {
	// Highlight the correct nav item when the slide changes
	$slider.on('afterChange', function() {
		const currentSlide = $(this).slick('slickCurrentSlide');
		const $currentNavItem = $el.sliderNav.find(`[data-slide='${currentSlide}']`);
		
		$el.sliderNav.find('button').not($currentNavItem).removeClass('is-active');
		$currentNavItem.addClass('is-active');
	});
}

function sliderNav($slickNav) {
	const slickNavFor = $slickNav.data('slick-nav-for');
	const $navItem = $slickNav.find('li');
	
	$navItem.each((i) => {
		$slickNav.find(`[data-slide='${i}']`).on('click', function() {
			$(`#${slickNavFor}`).slick('slickGoTo', i);
		});
	});
}
